(function () {
  const preloader = document.getElementById('MarikaPreloader');
  if (!preloader) return;

  const SESSION_KEY = 'marika-preloader-shown';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let alreadyShown = false;
  try {
    alreadyShown = sessionStorage.getItem(SESSION_KEY) === '1';
  } catch (e) {
    alreadyShown = false;
  }

  if (alreadyShown || prefersReducedMotion) {
    preloader.remove();
    return;
  }

  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch (e) {
    // Storage unavailable (private mode, etc.) — preloader will just replay
    // on every page in that case, which is a harmless fallback.
  }

  document.documentElement.classList.add('marika-preloader-active');

  // Fixed-duration intro (matches the original site's opening screen) rather
  // than a load-tied progress indicator — shown for exactly this long
  // regardless of how fast the rest of the page loads.
  const duration = parseInt(preloader.dataset.marikaPreloaderDuration, 10) || 1500;

  window.setTimeout(() => {
    preloader.classList.add('marika-preloader--done');
    document.documentElement.classList.remove('marika-preloader-active');
    window.setTimeout(() => preloader.remove(), 500);
  }, duration);
})();
